import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { PortalService } from '@vsolv/packages/portal-config/web';
@Component({ changeDetection: ChangeDetectionStrategy.Eager, templateUrl: './not-found.page.html', standalone: false })
export class NotFoundPage implements OnInit {
  portalSvc = inject(PortalService);

  async ngOnInit(): Promise<void> {
    this.loadConfig();
  }

  loadConfig() {
    const localConfig = localStorage.getItem('config');
    if (localConfig) {
      this.portalSvc.setTheming(JSON.parse(localConfig));
    }
  }
}
